import styles from '@percent/cause-dashboard/app/home/profileCompletionProgress/tasks/task/Task.module.scss'
import { FakeCheckbox } from '@percent/lemonade'
import { Text } from '@percent/lemonade'
import { Link } from 'react-router-dom'

type TaskProps = {
  title: {
    text: string
    link?: string
    onClick?: VoidFunction
  }
  description: string
  isCompleted: boolean
  disabled?: boolean
  strikethrough?: boolean
  disableHover?: boolean
}

export const Task = ({ title, description, isCompleted, disabled, strikethrough, disableHover }: TaskProps) => {
  const titleText = strikethrough ? <s>{title.text}</s> : title.text

  return (
    <div className={disabled ? styles.wrapperDisabled : styles.wrapper}>
      <div className={disabled ? styles.titleWrapperDisabled : styles.titleWrapper}>
        <div className={disableHover ? styles.checkboxNoHover : undefined}>
          <FakeCheckbox isSelected={isCompleted} />
        </div>
        {title.link ? (
          <Link to={title.link} className={styles.link} onClick={title.onClick}>
            <Text size="small">{titleText}</Text>
          </Link>
        ) : (
          <Text size="small">{titleText}</Text>
        )}
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  )
}
